interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "classic" | "outline" | "ghost";
}

export const Button = ({ children, variant = "classic", className, ...props }: ButtonProps) => {
  if (variant === "outline") {
    return (
      <button
        className={`flex items-center gap-2 bg-white px-4 py-2  rounded-4xl font-medium text-motion600 border-2 border-motion600 cursor-pointer ${className} disabled:opacity-50 disabled:cursor-not-allowed`}
        {...props}
      >
        {children}
      </button>
    );
  }

  if (variant === "ghost") {
    return (
      <button
        className={`flex items-center gap-2 bg-white px-4 py-2 rounded-4xl  text-textDefault border-2 border-slate-400 cursor-pointer ${className} disabled:opacity-50 disabled:cursor-not-allowed`}
        {...props}
      >
        {children}
      </button>
    );
  }
  return (
    <button
      className={`flex items-center gap-2 bg-motion600 px-4 py-2 rounded-4xl text-white cursor-pointer ${className} disabled:opacity-50 disabled:cursor-not-allowed`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
